<template>
  <div class="flex flex-col gap-4">
    <TweetCard v-for="tweet in tweets" :tweet="tweet" />
  </div>
</template>

<script lang="ts" setup>
import type { Tables } from '~/types/database-helpers';
defineProps<{
  tweets: Tables<'tweets'>[];
}>();
</script>
